import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles";
import palette from "./palette";
let theme = createMuiTheme({
  palette: palette,
  direction: "rtl",
  spacing: 2,
  overrides: {
    MuiAutocomplete: {
      popper: { zIndex: 13000 },
    },
  },
  typography: {
    h1: {
      fontSize: "1.9rem",
      fontWeight: "bold",
    },

    h2: {
      fontSize: "1.8rem",
      fontWeight: "bold",
      textAlign: "left",
    },
    h3: {
      fontSize: "1.6rem",
      fontWeight: "bold",
      textAlign: "left",
    },
    h4: {
      fontSize: "1.3rem",
      fontWeight: "500",
    },
    h5: {
      fontSize: "1.1rem",
    },
    h6: {
      fontSize: "0.98rem",
    },
    body1: {
      fontSize: "0.93rem",
    },
    body2: {
      fontSize: "0.8rem",
    },
    caption: {
      fontSize: "0.81rem",
    },
    allVariants: {
      fontFamily: "iranSans",
    },
  },
});
export default responsiveFontSizes(theme);
